import { fromJS } from 'immutable';
import { DONE, FAILED, SENDING } from './constants';
import { APP_RESET } from '../App/constants';

const initialState = fromJS({ sending: false, message: null, error: null });

function reducer(state = initialState, action) {
  switch (action.type) {
    case SENDING:
      return initialState.set('sending', true);
    case DONE:
      return initialState.set('message', action.payload.message);
    case FAILED:
      return initialState.set('error', action.payload.error);
    // Each page starts clean (the app resets on every route change).
    case APP_RESET:
      return initialState;
    default:
      return state;
  }
}

export default reducer;
